<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M17.318 5.96c.737-.818 2.092-.888 2.543.1.405.887.523 1.886.307 2.863l-.835 3.787h8c1.105 0 2 .852 2 1.903v2.242c0 .195-.04.389-.115.57l-3.047 7.247c-.506 1.204-1.732 1.994-3.095 1.994h-12.41V13.344l6.652-7.385zM8.666 25.665a1 1 0 01-1 1h-4a1 1 0 01-1-1V14.333a1 1 0 011-1h4a1 1 0 011 1v11.333z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsLikeFilled'
}
</script>
